import { createFileRoute } from '@tanstack/react-router'

import { AgendaPage } from '@/components/pages/Dashboard/AgendaPage'

export const Route = createFileRoute('/e/$eventId/_dashboard/agenda')({
  component: AgendaPage,
})
